var FuzzyReaction = require('../bootstrap').FuzzyReaction;
var AppDispatcher = FuzzyReaction.Dispatcher;
var AppActionConstants = require('../constants/AppActionConstants');
var assign = require('object-assign');
var ModelStore = FuzzyReaction.Stores.ModelStore;

/**
 * Data stores
 * @type {Array}
 * @private
 */
// Store for user table data
var _resourceListData = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
var SubscriptionTypesStore = assign({}, ModelStore, {
	getResourceListData: function () {
		return _resourceListData;
	}
});

/**
 * Event Listeners
 */
SubscriptionTypesStore.dispatchToken = AppDispatcher.register(function(action) {
	switch(action.type) {
		case 'PRODUCTS_LISTED':
			_resourceListData = action.data;

			SubscriptionTypesStore.emitChange();
			break;
	}
});

module.exports = SubscriptionTypesStore;
